export default "__VITE_ASSET__JvCD4R00__"